import GenericBanner from './GenericBanner';

export default GenericBanner;
